import * as Styled from "./style";
import { NextLink } from "~/components/blocks/common/next-link";
import type { Href } from "~/const/hrefs";

type HeadingLinkProps = {
  heading: string;
  href?: Href;
  isShowEditBtn?: boolean;
  isEdit?: boolean;
  onEditAction?: () => void;
};

/**
 * 各セクションの見出しとリンクを表示するコンポーネント
 * @param props {@link HeadingLinkProps}
 */
export const HeadingLink = (props: HeadingLinkProps) => {
  const { heading, href, isShowEditBtn, isEdit, onEditAction } = props;

  return (
    <Styled.DivHeadingBox>
      <Styled.DivLeftTextWrapper>
        {href ? (
          <NextLink href={href} scroll={true}>
            <>
              <Styled.Heading size="L">{heading}</Styled.Heading>
              <Styled.Icon name="arrowRight" color="GRAY900" />
            </>
          </NextLink>
        ) : (
          <Styled.Heading size="L">{heading}</Styled.Heading>
        )}
      </Styled.DivLeftTextWrapper>

      {isShowEditBtn && (
        <Styled.Button
          name="edit"
          color="BLUE900"
          bgColor="TRANSPARENT"
          mainText={isEdit ? "完了" : "編集"}
          onClick={() => onEditAction && onEditAction()}
        />
      )}
    </Styled.DivHeadingBox>
  );
};
